import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  resetStatus({ commit }) {
    commit(types.RESET_STATUS)
  },
  setStatus({ commit }, data) {
    commit(types.SET_STATUS, data)
  },
  async getCalibration({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getCalibration', () =>
      http.get(`servicerequest/getCalibration?id=${id}&verbose=false`)
    )
    commit(types.SET_CALIBRATION, r.data)
    return r.data
  },
  async saveCalibration({ dispatch }, data) {
    const r = await startLoading(dispatch, 'saveCalibration', () =>
      http.post(`servicerequest/saveCalibration`, data)
    )
    return r.data
  },
  async getAlignmentInfo({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getAlignmentInfo', () =>
      http.get(`event/GetAlignmentInfo?id=${id}`)
    )
    commit(types.SET_ALIGNMENTSPECS, r.data)
    return r.data
  },
  async getAimingUrls({ commit, dispatch }, data) {
    const hunterNetUrl = window.config ? window.config.hunterNetUrl : ''
    if (hunterNetUrl !== '') {
      const r = await startLoading(dispatch, 'getAimingUrls', () =>
        http.get(`alignment-images?procedureGuid=${data}`, {}, { headers: [] }, hunterNetUrl)
      )
      commit(types.SET_AIMING_URLS, r.data)
      return r.data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/calibration/actions.js